import React from 'react';
import { GridItem, Stack } from '@guestyci/arc';
import AuthImage from './AuthImage';
import AuthImageMobile from './AuthImageMobile';

const AuthImageBlock = ({ showStepper = false }) => (
  <>
    <GridItem
      gridColumnStart={{ xs: 1, md: 1, lg: 2 }}
      gridRowStart={{ xs: 1, md: 1, lg: 1 }}
      className="gst-block md:gst-block lg:gst-hidden gst-overflow-hidden"
      style={{ marginRight: -20 }}
    >
      <AuthImageMobile alt="" />
    </GridItem>

    <GridItem
      gridColumnStart={{ xs: 1, md: 1, lg: 2 }}
      gridRowStart={{ xs: 1, md: 1, lg: 1 }}
      gridRowEnd={{ xs: 1, md: 1, lg: showStepper ? 4 : 3 }}
      className="gst-hidden md:gst-hidden lg:gst-block"
    >
      <Stack
        align="center"
        justify="center"
        className="gst-p-16 gst-sticky"
        style={{ top: 64, height: 'calc(100vh - 64px)' }}
      >
        <AuthImage alt="" className="gst-max-h-full" />
      </Stack>
    </GridItem>
  </>
);

export default AuthImageBlock;
